var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestingIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.286,
    height: 48,
    viewBox: "0 0 34.286 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Add_note",
    "data-name": "Add note",
    d: "M208.771,50.086,197.629,35.857A2.11,2.11,0,0,0,195.914,35H178.429A3.439,3.439,0,0,0,175,38.429V79.571A3.439,3.439,0,0,0,178.429,83h27.429a3.439,3.439,0,0,0,3.429-3.429V51.286A1.852,1.852,0,0,0,208.771,50.086Zm-9.6,20.4h-5.143v5.143a1.714,1.714,0,1,1-3.429,0V70.486h-5.143a1.714,1.714,0,0,1,0-3.429H190.6V61.914a1.714,1.714,0,1,1,3.429,0v5.143h5.143a1.62,1.62,0,0,1,1.714,1.714A1.844,1.844,0,0,1,199.171,70.486ZM206.371,53H194.543a.168.168,0,0,1-.171-.171V37.914a.328.328,0,0,1,.514-.171l11.829,14.914A.369.369,0,0,1,206.371,53Z",
    transform: "translate(-175 -35)",
    fill: "#86bc26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingIcon2);
export default __webpack_public_path__ + "static/media/testing-icon-2.c7c0777130410eb992e4681c0f559d0b.svg";
export { ForwardRef as ReactComponent };